import React from "react";

import { BrowserRouter as Router, Route } from "react-router-dom";
import City from "./Views/City";

const App = () => {
  return (
    <Router>
      <div>
        <Route exact path="/" component={City} />
        <Route path="/city" component={City} />
      </div>
    </Router>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js